<script>
import throttle from 'lodash/throttle'
export default {
 	render (createElement) {
		return this.$scopedSlots.default()
	},

  data () {
    return {
      x: 0,
      y: 0,
      event: {},
    }
  },
  
	mounted() {
		this.$el.addEventListener('mouseleave', this.processLeave)
		this.$el.addEventListener('mousemove', this.processMouseMovement)
    this.$el.addEventListener('wheel', this.processMouseMovement)
	},

	beforeDestroy() {
		this.$el.removeEventListener('mouseleave', this.processLeave)
		this.$el.removeEventListener('mousemove', this.processMouseMovement)
		this.$el.removeEventListener('wheel', this.processMouseMovement)
  },

	methods: {
		processMouseMovement: throttle(function (event) {
			this.x = event.clientX
      this.y = event.clientY
      this.event = event
		}, 20),
		processLeave: function(event) {
      setTimeout(() => {
        this.x = -1
        this.y = -1
      }, 21); //throotle time from processMouseMovement...
		}
  },
  computed: {
    value () {
      return {
        x: this.x,
        y: this.y,
        event: this.event
      }
    }
  },
  
	reactiveProvide: {
		name: 'MousePosition',
    include: [ 'value' ]
	}
}

</script>
